//<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card">
        <Toolbar class="p-mb-4 p-p-2">
          <template #start>
            <div style="font-size: 1.4em; color: inherit" class="p-p-2">{{ $t('Error Logs') }} </div>
          </template>
        </Toolbar>

        <!--  Desktop DataTable -->
        <Spinner v-if="isLoading"/>
<!--        <DesktopDataTable v-else-if="!isLoading && !$store.state.tabletLayout"-->
        <DesktopDataTable v-else
                          :dataTableIsLoading="dataTableIsLoading"
                          :showHeader="false"
                          :itemsArrayIsEmpty="itemsArrayIsEmpty"
                          :sort="sort"
                          :showButtons="!!actionButtonsCount"
                          :showSearchInput="false"
                          :actionButtonsCount="actionButtonsCount"
                          @sort-items="sortItems"
                          :headers="[
                              {name: 'created_at', title: $t('Created'), sortable: true},
                              {name: 'level', title: 'Level', sortable: false},
                              {name: 'controller', title: 'Controller', sortable: false},
                              {name: 'action', title: 'Action', sortable: false},
                              {name: 'request_url', title: 'Request Url',sortable: false},
                              {name: 'message', title: 'Message', sortable: false},
                              {name: 'request_data', title: 'Request Data', sortable: false},
                          ]">
          <template v-slot:body>
            <tr v-for="(item, index) of items"
                :key="index"
                :class="{'updated-item': isItemUpdated(item.id)}">
              <td>
                {{ formatDate(item.created_at, true) }}
              </td>
              <td>
                <span v-if="item.level === 1">Error</span>
                <span v-else-if="item.level === 2">Warning</span>
                <span v-else-if="item.level === 3">Info</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.controller">{{ item.controller }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.action">{{ item.action }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.request_url">{{ item.request_url }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.message">{{ item.message }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td class="text-wrap">
                <span v-if="item.request_data">{{ item.request_data }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td v-show="actionButtonsCount">
                <div class="actions">
                  <DeleteButton @click="confirmItemDelete(item)"
                                :disabled="dataTableIsLoading"/>
                </div>
              </td>
            </tr>
          </template>
        </DesktopDataTable>

        <OwnPaginator v-show="!itemsArrayIsEmpty"
                      :rows="pagination.perPage"
                      :currentPage="pagination.currentPage - 1"
                      :totalPages="pagination.pageCount"
                      :totalRecords="pagination.totalCount"
                      :rowsPerPageOptions="[5,10,25,50,100,200]"
                      :pageLinkSize="11"/>

        <TotalRecordsData :pagination="pagination" :itemsArrayIsEmpty="itemsArrayIsEmpty"/>

        <ConfirmDeleteModal :visible="confirmItemDeleteModal"
                            :modalDataIsLoading="modalDataIsLoading"
                            @close="closeConfirmItemDeleteModal"
                            @delete-item="deleteItem"/>
			</div>
		</div>
	</div>
</template>

<script>
import httpClient from '@/services/http.services'
import formatMixins from "@/mixins/formatMixins";
import datatableMixins from "@/mixins/datatableMixins";
import settings from "@/settings";
import showErrorsMixins from "@/mixins/showErrorsMixins";
// import {maskAttemptedLogin, maskIp} from "@/utils/mask";

export default {
  mixins: [ formatMixins, datatableMixins, showErrorsMixins ],
	data() {
		return {
      fieldsExpand: 'user',
      apiLink: 'error-log',
      deleteItemUrl: 'error-log/delete',
      routePath: '/error-logs',
      searchData: '',
      sort: {
        column: 'created_at',
        direction: '-',
      },
		}
	},
  mounted() {
    this.scrollToTop()
    if (settings.autoLogoutTimeout && this.$store.state.logoutTimestampIsOverdue) return false
    this.checkRouteQuery()
    // if (!this.$store.state.user?.role) return
    // this.getItems()
    this.getPageData()
	},
  methods: {
    getPageData() {
      // if (!this.userCanGetData || this.fetchInFlight) return
      this.getItems()
    },
    async getItems() {
      // if (!this.$store.getters.isUserReady) return
      if (!this.userCanGetData || this.fetchInFlight) return
      this.$store.commit('SET_FETCH_IN_FLIGHT', true)
      this.dataTableIsLoading = true
      const ctrl = this.setController?.('errorLogs')
      try {
        const { status, data, headers } = await httpClient({
          url: this.apiLink,
          params: {
            // type: this.selectedTypeId,
            page: this.pagination.currentPage,
            'per-page': this.pagination.perPage,
            sort: this.sort.direction + this.sort.column,
            search: this.searchData,
            expand: this.fieldsExpand,
          },
          signal: ctrl?.signal
        })
        if (status === 200 && data && Array.isArray(data)) {
          const hasPaginationHeaders = !!headers['x-pagination-total-count']
          if (hasPaginationHeaders) {
            this.pagination.totalCount = +headers['x-pagination-total-count']
            this.pagination.pageCount  = +headers['x-pagination-page-count']
          } else {
            this.pagination.totalCount = data.length
            this.pagination.pageCount  = 1
          }

          this.items = data

          if (!data.length) {
            this.pagination.pageCount = 1
            this.pagination.currentPage = 1
          }
        } else {
          this.items = []
          this.showUnknownError()
        }
      } catch(err) {
        this.items = []
        this.showError(err)
      } finally {
        this.$store.commit('SET_FETCH_IN_FLIGHT', false)
        this.dataTableIsLoading = false
        this.isLoading = false
        if (this._abortors?.errorLogs === ctrl) {
          this._abortors.errorLogs = null
        }
      }
    },
	},
  computed: {
    actionButtonsCount() {
      return 1
    },
  }
}
</script>

<style scoped lang="scss">

</style>